export default __webpack_public_path__ + "static/media/next-elevatepro.aa58c7b9.jpg";